import { render, staticRenderFns } from "./framework.vue?vue&type=template&id=320e5a60&scoped=true"
import script from "./framework.vue?vue&type=script&lang=js"
export * from "./framework.vue?vue&type=script&lang=js"
import style0 from "./framework.vue?vue&type=style&index=0&id=320e5a60&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320e5a60",
  null
  
)

export default component.exports